/**
 *
 * AmCharts/Serial
 *
 */

import React, { useEffect, useState } from 'react'

import 'amcharts3'
import 'amcharts3/amcharts/serial'
import AmCharts from '@amcharts/amcharts3-react'

function Serial({ config }) {
	const [chart, setChart] = useState(null)

	useEffect(() => {
		if (chart) {
			chart.validateData()
		}
	}, [config])

	const defaultConfig = {
		pathToImages: '/amcharts/images/',
		type: 'serial',
		categoryField: 'category-1',
		colors: ['#1ABC9C', '#EB6B56', '#1ABC9C', '#EB6B56', '#16A1D4'],
		startDuration: 1,
		categoryAxis: {
			gridPosition: 'start',
			parseDates: config.categoryField === 'date' || config.categoryField === 'time',
			// "minPeriod": props.period
		},
		dataDateFormat: 'YYYY-MM-DD',
		chartScrollbar: {
			enabled: true,
		},
		valueScrollbar: {
			autoGridCount: true,
			color: '#000000',
			scrollbarHeight: 50,
			enabled: true,
		},
		trendLines: [],
		graphs: [
			{
				balloonText: '[[title]] of [[category]]:[[value]]',
				fillAlphas: 1,
				id: 'AmGraph-1',
				title: 'Graph One',
				type: 'column',
				valueField: 'category-1',
				xAxis: 'ValueAxis-1',
				yAxis: 'ValueAxis-1',
			},
		],
		guides: [],
		valueAxes: [
			{
				id: 'ValueAxis-1',
				stackType: 'regular',
				title: '',
			},
		],
		allLabels: [],
		balloon: {},
		legend: {
			enabled: true,
			useGraphSettings: true,
		},
		titles: [],
		dataProvider: [],
		listeners: [
			{
				event: 'init',
				method: (e) => setChart(e.chart),
			},
		],
	}

	const chart_config = Object.assign(defaultConfig, config)

	return (
		<div className="unzoom h-100">
			<AmCharts.React style={{ width: '100%', height: '100%' }} options={chart_config} />
		</div>
	)
}

Serial.propTypes = {}

export default Serial
